export default __webpack_public_path__ + "images/LW.0aa5ccd.png";